import styled from 'styled-components';


export const ContainerLinkParagraph = styled.div`
    margin: 0 0 60px 0;
    display: inline-block;
`